import React, { Component } from "react";
import { Navigate, redirect } from "react-router-dom";
import { ApplicationEnum, UserRole } from "../Pages/ApiCommonService";
import PageNotFound from "../Pages/PageNotFound";

interface DefaultRouteProps {
  roleId?: number;
  selectedAppId?: number;
}

class DefaultRoute extends Component<DefaultRouteProps> {
  render() {
    const { roleId,selectedAppId } = this.props;

    let redirectPath = "";

    if (roleId === UserRole.CSR || roleId === UserRole.BrokerAdmin) {
      redirectPath = "home/csrdashboard";
    }

    if (roleId === UserRole.ExdionAdmin) {
      redirectPath = "introducebroker";
    }

    if (roleId === UserRole.MSUser) {
      redirectPath = "InterUpload";
    }

    if (roleId === UserRole.Reviewer || roleId === UserRole.QA) {
      redirectPath = "home/dashboard";
    }

    if (roleId === UserRole.Supervisor) {
      redirectPath = "jobs/joblisting";
    }

    if (selectedAppId === ApplicationEnum.UserManagement) {
      redirectPath = "usermaster";
    }

    return redirectPath ? <Navigate to={redirectPath} replace /> : null;
  }
}


export default DefaultRoute;
